var _circle, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 282,
    viewBox: "0 0 283 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 141.5,
    cy: 141,
    r: 141,
    fill: "#A7A6CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.16 220.747s-15.018-46.172-10.877-69.562c3.694-20.874 10.869-49.903 12.37-55.906a.47.47 0 0 1 .864-.118c3.419 6.029 20.246 38.827 7.623 80.361-13.995 46.046-9.979 45.225-9.979 45.225z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M201.13 110.228c.138 6.883-.055 13.761-.435 20.63a285 285 0 0 1-1.89 20.549 249 249 0 0 1-1.562 10.205 208 208 0 0 1-2.065 10.119c-.797 3.35-1.683 6.68-2.689 9.977a125 125 0 0 1-3.479 9.739.376.376 0 1 1-.695-.282v-.001l.002-.004a124 124 0 0 0 3.499-9.66 164 164 0 0 0 2.719-9.92 209 209 0 0 0 2.102-10.075q.906-5.069 1.601-10.172a284 284 0 0 0 1.977-20.502c.408-6.854.631-13.729.524-20.591v-.004a.195.195 0 0 1 .193-.199.194.194 0 0 1 .198.191",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.711 230.751s2.879-48.465 15.276-68.731c11.063-18.087 28.344-42.497 31.934-47.539a.47.47 0 0 1 .848.205c.981 6.86 4.67 43.531-22.252 77.598-29.845 37.768-25.806 38.467-25.806 38.467",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M237.77 129.302c-2.386 6.46-5.078 12.792-7.939 19.049a285 285 0 0 1-9.265 18.443 250 250 0 0 1-5.18 8.931 209 209 0 0 1-5.618 8.668 165 165 0 0 1-6.147 8.308 125 125 0 0 1-6.796 7.799.375.375 0 0 1-.544-.517v-.001l.004-.003a125 125 0 0 0 6.785-7.719 165 165 0 0 0 6.155-8.243 209 209 0 0 0 5.636-8.614 250 250 0 0 0 5.206-8.886 284 284 0 0 0 9.328-18.368c2.884-6.232 5.601-12.552 8.007-18.98l.002-.003a.195.195 0 0 1 .251-.115.194.194 0 0 1 .115.251",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.586 107.564c4.475 12.845 32.793 86.421 88.788 68.98 0 0-9.392-53.828-87.899-70.549-.686-.146-1.182.73-.89 1.569",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M50.153 114.736c2.398 3.266 4.923 6.446 7.498 9.578q3.871 4.696 7.943 9.217c5.43 6.025 11.126 11.816 17.157 17.236 6.033 5.41 12.401 10.472 19.258 14.782a96 96 0 0 0 5.237 3.064 81 81 0 0 0 5.437 2.679c3.692 1.636 7.532 2.948 11.479 3.754h.002a.376.376 0 0 1-.15.735h-.002c-4.01-.837-7.892-2.185-11.614-3.853a82 82 0 0 1-5.473-2.728 96 96 0 0 1-5.26-3.108c-6.879-4.369-13.247-9.477-19.273-14.929-6.023-5.462-11.703-11.29-17.116-17.347a279 279 0 0 1-7.913-9.266c-2.566-3.149-5.077-6.34-7.47-9.629a.16.16 0 0 1 .036-.222.16.16 0 0 1 .223.036z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.916 41.138c.173-1.143 1.24-.92 2.148-.203 49.68 39.23 69.231 112.882 56.387 134.036 0 0-77.415-9.333-58.535-133.833",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M86.302 56.31c.048.278.124.588.19.885l.217.898.453 1.794q.465 1.79.955 3.575a342 342 0 0 0 2.05 7.11 385 385 0 0 0 4.5 14.097c3.196 9.333 6.687 18.567 10.642 27.602 1.995 4.509 4.034 8.999 6.25 13.403q.404.832.834 1.65l.849 1.642.849 1.642c.287.545.587 1.083.88 1.625.594 1.08 1.171 2.17 1.778 3.242l1.84 3.206c.154.267.303.536.461.8l.478.791.958 1.581.957 1.581c.326.523.666 1.038.997 1.556l1.001 1.554c.338.515.657 1.043 1.015 1.546l2.096 3.045a141 141 0 0 0 9.141 11.619.12.12 0 0 1-.011.173.12.12 0 0 1-.17-.008c-3.354-3.635-6.45-7.5-9.372-11.491l-2.134-3.034c-.363-.501-.689-1.027-1.033-1.54l-1.02-1.549c-.339-.517-.685-1.03-1.017-1.551l-.977-1.577-.976-1.576-.489-.788c-.161-.264-.314-.533-.471-.799-5.03-8.517-9.449-17.385-13.391-26.45l-1.46-3.407-1.409-3.429c-.477-1.14-.914-2.296-1.372-3.443l-.68-1.724-.657-1.733a319 319 0 0 1-4.969-13.965 355 355 0 0 1-4.372-14.16 345 345 0 0 1-1.943-7.15 276 276 0 0 1-.901-3.595l-.426-1.803-.203-.905c-.062-.306-.133-.596-.182-.928a.121.121 0 0 1 .239-.04z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.662 235.583h141.895v-28.38H72.662c3.037 0 3.037 28.38 0 28.38",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.556 228.481v-12.988c0-4.578-2.804-8.29-6.263-8.29H73.26a4.923 4.923 0 0 1-4.925-4.921c0-.826.67-1.496 1.496-1.496h147.582c3.384 0 8.758 5.318 8.758 11.877v18.139c0 6.185-5.217 11.198-8.408 11.198H70.607a2.27 2.27 0 0 1-2.273-2.271 4.147 4.147 0 0 1 4.149-4.146h136.708c2.963 0 5.365-3.18 5.365-7.102",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62 213.27H77.574a.243.243 0 1 1 0-.487H210.62a.244.244 0 1 1 0 .487",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62 217.483H77.574a.244.244 0 1 1 0-.488H210.62a.244.244 0 1 1 0 .488",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62 221.695H77.574a.244.244 0 1 1 0-.487H210.62a.244.244 0 1 1 0 .487",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62 225.908H77.574a.244.244 0 1 1 0-.488H210.62a.244.244 0 1 1 0 .488",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62 230.12H77.574a.244.244 0 1 1 0-.488H210.62a.244.244 0 1 1 0 .488",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.448 169.86H91.582a4.905 4.905 0 0 0-4.906 4.903v20.992a4.904 4.904 0 0 0 4.906 4.902h117.866a4.905 4.905 0 0 0 4.906-4.902v-20.992a4.905 4.905 0 0 0-4.906-4.903",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.449 197.118h13.954a.523.523 0 0 0 .523-.522v-22.674a.523.523 0 0 0-.523-.522h-13.954a.52.52 0 0 0-.522.522v22.674c0 .288.234.522.522.522m-2.995 0h-5.099a.265.265 0 0 1-.265-.265v-23.188c0-.147.119-.265.265-.265h5.099c.146 0 .265.118.265.265v23.188a.265.265 0 0 1-.265.265",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.027 170.023H223.91a1.45 1.45 0 0 0 1.45-1.449v-23.922a1.45 1.45 0 0 0-1.45-1.45H79.027a1.45 1.45 0 0 0-1.45 1.45v23.922c0 .8.648 1.449 1.45 1.449",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89 148.147h-13.825c-.977 0-1.768.791-1.768 1.767v14.529c0 .976.791 1.767 1.768 1.767h13.825c.977 0 1.768-.791 1.768-1.767v-14.529c0-.976-.791-1.767-1.768-1.767m-18.291 0h-4.723a.896.896 0 0 0-.896.896v16.272c0 .494.402.895.896.895h4.723a.896.896 0 0 0 .896-.895v-16.272a.896.896 0 0 0-.896-.896m25.796-.738h-3.093a.896.896 0 0 0-.896.895v16.272c0 .494.401.895.896.895h3.093a.896.896 0 0 0 .896-.895v-16.272a.896.896 0 0 0-.896-.895",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.887 178.496c.052-.02 28.576-49.935 32.43-54.632a2.99 2.99 0 0 1 2.668-1.072l7.961.948 9.353 20.219-15.582-9.068c1.542 10.656-18.475 26.491-25.34 32.269a1.575 1.575 0 0 0-.125 2.295l2.74 2.867c-4.498 4.557-9.69 7.484-15.55 8.837z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.408 170.776s1.749.565 2.34 2.121c.284.744-.022 1.588-.67 2.052-2.879 2.062-12.38 8.719-16.764 10.023a.496.496 0 0 1-.62-.584c.225-1.018.953-3.05 3.297-6.025l-.21.425c-.267.538.32 1.098.843.803 2.933-1.654 8.905-5.275 11.784-8.816z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.996 190.747c.048-.031 4.328-10.334 4.375-10.364 3.924-23.872 13.497-44.317 16.32-49.697a2.99 2.99 0 0 1 2.395-1.588l7.989-.682 13.254 17.909-17.096-5.729c3.668 10.123-12.727 29.679-18.28 36.726a1.574 1.574 0 0 0 .343 2.272l3.265 2.253c-3.483 5.373-7.976 9.289-13.44 11.8z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.694 180.653s1.827.199 2.722 1.604c.428.672.301 1.56-.24 2.145-2.403 2.602-10.359 11.043-14.388 13.206a.495.495 0 0 1-.725-.446c.014-1.043.315-3.181 2.008-6.568l-.12.459c-.151.581.536 1.011.989.616 2.536-2.212 7.652-6.966 9.754-11.017z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.468 124.644s7.226 10.741 7.819 15.641c.593 4.899-1.998 6.594-9.562 7.219-22.509 1.859-33.605-4.882-33.605-4.882-1.54-9.811-2.635-12.306-15.495-17.641 0 0 16.266 1.291 19.539.021s31.304-.358 31.304-.358",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65 64.467s5.034-5.95 10.385 1.35c.969 1.323 4.692.232 6.056 3 .705 1.429 2.227 2.24 3.795 1.952 3.905-.72 10.287-.78 13.438 5.334 2.406 4.667.548 7.399-1.856 8.956-1.766 1.143-2.396 3.466-1.328 5.278 1.024 1.738 1.217 4.092-1.428 6.924-5.927 6.348-17.659-4.028-17.659-4.028l-9.315-21.997-2.087-6.769z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.925 123.222s-8.416-8.007-12.558-13.311a11.25 11.25 0 0 1-1.906-10.127c1.891-6.368 5.252-12.962 5.559-13.989.47-1.573 9.905-1.508 9.905-1.508s18.568 12.043 25.864 32.441l-8.193 2.549s-4.848-8.128-9.638-13.295c0 0 8.289 10.941 8.58 15.421z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.891 126.383 6.323-6.875 7.303 1.965s8.514 1.318 13.387 0l4.873-1.318 11.012-3.426 1.729 4.884a2.94 2.94 0 0 1-1.075 3.379c-.953.676-2.069 1.419-2.781 1.731-1.45.634-33.405.201-33.405.201z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.439 72.951 6.342 11.785c-.419 2.572-6.903 2.644-7.904 1.109a1.5 1.5 0 0 1-.199-.52l-3.794-7.874c-.163-.768 1.943-3.355 2.637-3.724l2.521-1.341c.97-.517-3.08-.557.397.565",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.604 70.185s-.716 3.982 2.415 9.044 6.25 4.834 7.835 3.029 3.482-4.812 2.618-9.861c-.863-5.05-11.787-7.288-12.868-2.212",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.682 72.945s-5.071-6.656-8.964-.854l.066 2.004s-5.063-.236-4.514-4.899 4.682-7.848 10.412-6.255c5.73 1.594 9.078 3.407 9.725 7.383s-2.601 3.325-2.601 3.325-1.241-2.743-2.74-2.93c-1.498-.188-.956 1.982-.956 1.982z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.846 72.767s-2.626-3.406-.236-4.113c2.391-.707 2.302 3.337 2.146 4.842l-1.911-.73z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.822 129.104-.067.001-29.086-.032a1.3 1.3 0 0 1-1.3-1.302c0-.718.586-1.312 1.303-1.299l29.085.032a1.301 1.301 0 0 1 .064 2.6z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.524 102.715h24.222a4.62 4.62 0 0 1 4.175 2.646l11.199 23.727h-30.102a2.81 2.81 0 0 1-2.61-1.773l-8.683-21.956a1.933 1.933 0 0 1 1.8-2.644z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.588 114.882c.525 1.629.137 3.212-.866 3.535s-2.242-.737-2.767-2.367-.137-3.212.866-3.535 2.242.737 2.767 2.367",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.32 92.9c14.619 0 26.469-11.843 26.469-26.45 0-14.608-11.85-26.45-26.469-26.45-14.618 0-26.468 11.842-26.468 26.45s11.85 26.45 26.468 26.45",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.49 79.856a.24.24 0 0 1-.207-.114 24.8 24.8 0 0 1-3.849-13.292c0-13.713 11.165-24.87 24.887-24.87q.346-.001.687.01c1.075.028 2.157.128 3.214.294a.244.244 0 1 1-.076.482 24.6 24.6 0 0 0-3.825-.298c-13.453 0-24.399 10.937-24.399 24.381 0 4.633 1.305 9.139 3.774 13.031a.244.244 0 0 1-.206.376m19.253 11.414h-.016a24.84 24.84 0 0 1-15.113-6.388.244.244 0 1 1 .327-.362 24.36 24.36 0 0 0 14.817 6.262.244.244 0 0 1-.015.487m22.17-38.105a.25.25 0 0 1-.204-.11 24.7 24.7 0 0 0-7.614-7.38.244.244 0 1 1 .255-.416 25.15 25.15 0 0 1 7.766 7.528.244.244 0 0 1-.203.378",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.32 55.133-22.132 6.742 22.132 6.741 22.131-6.74z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.32 70.979-13.929-4.243v9.692a3.37 3.37 0 0 0 2.67 3.297c7.48 1.585 14.673 1.634 21.56.052a3.36 3.36 0 0 0 2.602-3.281v-9.447zM181.313 75q-1.815.806-3.175.033a.71.71 0 0 1-.336-.758l1.97-9.787 1.955 9.714a.72.72 0 0 1-.414.798",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.321 60.876-18.835 2v3.265h.558l.058-2.861z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 68.334,
    y1: 221.393,
    x2: 226.17,
    y2: 221.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 77.33,
    y1: 213.027,
    x2: 210.864,
    y2: 213.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 77.33,
    y1: 217.238,
    x2: 210.864,
    y2: 217.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 77.33,
    y1: 221.451,
    x2: 210.864,
    y2: 221.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 77.33,
    y1: 225.664,
    x2: 210.864,
    y2: 225.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 77.33,
    y1: 229.876,
    x2: 210.864,
    y2: 229.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 174.664,
    y1: 81.457,
    x2: 158.152,
    y2: 135.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 74.049,
    y1: 136.683,
    x2: 119.002,
    y2: 162.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 79.922,
    y1: 162.319,
    x2: 100.152,
    y2: 211.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 78.4,
    y1: 143.079,
    x2: -75.397,
    y2: 46.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 87.759,
    y1: 175.121,
    x2: 117.488,
    y2: 219.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 337.974,
    y1: 624.835,
    x2: 380.895,
    y2: 731.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 123.978,
    y1: 49.601,
    x2: 143.515,
    y2: 72.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 180.047,
    y1: 10.817,
    x2: 167.853,
    y2: 46.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 152.811,
    y1: 121.899,
    x2: 197.606,
    y2: 121.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 134.554,
    y1: 100.479,
    x2: 135.588,
    y2: 84.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 136.092,
    y1: 86.865,
    x2: 116.622,
    y2: 49.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 111.738,
    y1: 65.724,
    x2: 139.031,
    y2: 71.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 140.555,
    y1: 84.535,
    x2: 121.085,
    y2: 47.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 150.769,
    y1: 121.36,
    x2: 127.684,
    y2: 128.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 57.606,
    y1: 28.488,
    x2: 80.046,
    y2: 67.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.5 40h202v202h-202z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpcoming);
export default __webpack_public_path__ + "static/media/noUpcoming.b1301cbf378ec1bc6aaf0d1768505747.svg";
export { ForwardRef as ReactComponent };